module.exports = __webpack_public_path__ + "static/media/35-hill.f11c10db.jpg";